module.exports = require("parse-json");


//////////////////
// WEBPACK FOOTER
// external "parse-json"
// module id = 79
// module chunks = 0